'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$WeekDayPayload(kind, days) {
  this.LT = null;
  this.EN = null;
  this.LT = kind;
  this.EN = days;
}
export { $c_Lpresto_types$WeekDayPayload as $c_Lpresto_types$WeekDayPayload };
$p = $c_Lpresto_types$WeekDayPayload.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$WeekDayPayload;
/** @constructor */
function $h_Lpresto_types$WeekDayPayload() {
}
export { $h_Lpresto_types$WeekDayPayload as $h_Lpresto_types$WeekDayPayload };
$h_Lpresto_types$WeekDayPayload.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$WeekDayPayload)) {
    var x = this.LT;
    var x$2 = x$0.LT;
    if ((x === x$2)) {
      var x$3 = this.EN;
      var x$4 = x$0.EN;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "WeekDayPayload";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.LT;
  }
  if ((n === 1)) {
    return this.EN;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.Hj = (function() {
  return this.LT;
});
function $isArrayOf_Lpresto_types$WeekDayPayload(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kv)));
}
export { $isArrayOf_Lpresto_types$WeekDayPayload as $isArrayOf_Lpresto_types$WeekDayPayload };
var $d_Lpresto_types$WeekDayPayload = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$WeekDayPayload, "presto.types$WeekDayPayload", ({
  kv: 1,
  d9: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$WeekDayPayload as $d_Lpresto_types$WeekDayPayload };
//# sourceMappingURL=presto.types$-Week-Day-Payload.js.map
